var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrapper},[_c('BackArrow',{class:_vm.$style.arrow}),_c('div',{class:_vm.$style.main},[_c('div',{ref:"container",class:_vm.$style.container},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }